module.exports = __webpack_public_path__ + "static/hero-logo-row-1-910a604d76a55bdbab2a6fc4480f9677.png";